import eyerCloud from '@/config/eyercloud'

const LAUDO_TIMEOUT_MS = 130000
const LAUDO_DEFAULT_RETRY_AFTER = 5

function blobToJson(blob) {
  return new Promise((resolve) => {
    if (!blob || typeof FileReader === 'undefined') return resolve({})
    const reader = new FileReader()
    reader.onload = () => {
      try {
        resolve(JSON.parse(reader.result))
      } catch (err) {
        resolve({})
      }
    }
    reader.onerror = () => resolve({})
    reader.readAsText(blob)
  })
}

class ConnectorService {

  async listPartners(clinicId) {
    const response = await eyerCloud.post('/api/v2/eyercloud/clinic/connector/partners', { clinicId })
    return response.data
  }

  async getFieldCatalog(partner) {
    const response = await eyerCloud.post('/api/v2/eyercloud/clinic/connector/field-catalog', { partner })
    return response.data
  }

  async preview(params) {
    const response = await eyerCloud.post('/api/v2/eyercloud/clinic/connector/preview', params)
    return response.data
  }

  async listJobs({ clinicId, partner, status } = {}) {
    const response = await eyerCloud.post('/api/v2/eyercloud/clinic/connector/jobs', { clinicId, partner, status })
    return response.data
  }

  async retryJobs({ clinicId, idempotencyKeys } = {}) {
    const response = await eyerCloud.post('/api/v2/eyercloud/clinic/connector/retry', { clinicId, idempotencyKeys })
    return response.data
  }

  async getExamResults({ clinicId, examId } = {}) {
    const response = await eyerCloud.post('/api/v2/eyercloud/clinic/connector/exam-results', { clinicId, examId })
    return response.data
  }

  async getLaudo(idempotencyKey) {
    const response = await eyerCloud.post('/api/v2/eyercloud/clinic/connector/laudo', { idempotencyKey }, {
      responseType: 'blob',
      timeout: LAUDO_TIMEOUT_MS,
      validateStatus: status => status === 200 || status === 202
    })

    if (response.status === 202) {
      const info = await blobToJson(response.data)
      return { status: 'preparing', retryAfter: Number(info.retryAfter) || LAUDO_DEFAULT_RETRY_AFTER }
    }

    return { status: 'ready', blob: response.data }
  }

  async dispatch({ partner, clinicId, examId, images, analyses, fieldMap } = {}) {
    const response = await eyerCloud.post('/api/v2/eyercloud/connector/dispatch', {
      partner,
      clinicId,
      examId,
      images,
      analyses,
      fieldMap
    })
    return response.data
  }
}

export default new ConnectorService()
